export const roadInfoCardStructure = [
    {
        "sectionName": "Характеристики",
        "columns": [
            [
                { format: "field", caption: "Полное наименование", field: "FullName", valueType: "string" },
                { format: "field", caption: "Краткое наименование", field: "Name", valueType: "string" },
                { format: "field", caption: "Шифр", field: "CipherId", valueType: "string" },
                { format: "field", caption: "Учётный номер", field: "AccountNumber", valueType: "date" },
                { format: "button", type: "documents", caption: "Документы" }
            ],
            [
                { format: "field", caption: "Статус", field: "StatusString", valueType: "string" },
                { format: "field", caption: "Входит в опорную сеть", field: "add.IsInHighwayNetwork", valueType: "boolean" },
                { format: "field", caption: "Дата ввода в эксплуатацию", field: "PuttingIntoOperationDate", valueType: "date" },
                { format: "field", caption: "Балансовая стоимость, тыс. руб.", field: "BeginningCost", valueType: "number" },
            ],
            [
                { format: "field", caption: "Протяжённость, км", field: "add.Length", valueType: "number" },
                { format: "field", caption: "Адрес начала дороги, км+м", field: "add.MaintenancePosition", valueType: "string" },
                { format: "field", caption: "Адрес конца дороги, км+м", field: "add.MaintenanceEnding", valueType: "string" },
                { format: "field", caption: "Число полос движения, шт.", field: "add.NumberOfLines", valueType: "number" },
            ],
            [
                { format: "field", caption: "Технические категории", field: "add.RoadCategories", valueType: "string" },
                { format: "field", caption: "Типы дорожной одежды", field: "add.RoadBedTypes", valueType: "string" },
                { format: "field", caption: "Дорожно-климатические зоны", field: "add.RoadClimaticZones", valueType: "string" },
                { format: "field", caption: "Тип местности по условиям увлажнения", field: "add.SoilMoisteningTypes", valueType: "string" },
            ],
        ]
    }
]